import { api } from "../../api/endpoints";


export const getADcdnStats = (year, month) => {
    return async (dispatch) => {
        dispatch({
            type: "SET_lOADING",
            payload: true
        })
        const response = await api.post(`/cdn/getADStats`, {year, month});
        if (response.status === 200) {
            dispatch({
                type: "SET_lOADING",
                payload: false
            })            
            dispatch({
                type: 'SAVE_RESULTS',
                payload: response.data,
            });
        }else{
            dispatch({
                type: "SET_lOADING",
                payload: false
            })               
        }
    };
};


